import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type BusinessEventEvents = 'VIEW_BUSINESS_EVENTS';

export const businessEvents: Record<BusinessEventEvents, MixpanelEvent> = {
  VIEW_BUSINESS_EVENTS: {
    eventDescription: 'View Business Events',
    eventKey: 'view-business-events',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.OVERFLOW_MENU_ITEM_BUTTON
  }
} as const;

export type BusinessEventOrigin = {
  route: string;
  context?: string;
};
